import ApiClient from '../ApiClient';

class AiAgentTemplatesAPI extends ApiClient {
  constructor() {
    super('ai_agent_templates', { accountScoped: true });
  }
}

export default new AiAgentTemplatesAPI();
